import { h } from "../../../_snowpack/pkg/preact.js";
export const ShareButton = ({
  onClick
}) => {
  return h("button", {
    className: "uiButton nudgeDown",
    tabIndex: 0,
    onClick: onClick
  }, "share world");
};